import { useMutation } from '@apollo/client';

import { UPDATE_BUYER_DETAILS } from '../graphql/mutations';

const useUpdateBuyerDetails = () => {
  const [updateBuyerDetails, result] = useMutation(UPDATE_BUYER_DETAILS);

  return {
    updateBuyerDetails,
    ...result,
  };
};

export default useUpdateBuyerDetails;
